export const setPageTitle = (title: string) => {
  document.title = title
}

export const printWindow = () => {
  window.print()
}
